export default [
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '証明写真',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-history',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'study-history',
    title: 'ゼミ・研究',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'club-activity',
    title: 'サークル活動',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'license-history',
    title: '保有資格',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'skill-list',
    title: '趣味・特技',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'parttime-job',
    title: 'アルバイト経験',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'reasonNew',
    title: '自己PR',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'reason',
    title: '志望動機',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'close-preview-button-above'
  }
]
